import {
  NumericReadOnlyField,
  ReadOnlyField,
  SimpleGrid,
  Stack,
} from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { YES_NO_OPTIONS } from '@bcba/types';
import { ReadOnlyYesNoRadio } from '../../../../../DigitalDossier/components/ReadOnlyYesNoRadio';
import { useCropPledgeInsuranceInformationContext } from '../../context/PledgeInsuranceInformationContext';

const PledgeInsuranceInformationForm = () => {
  const { t } = useTranslation();
  const { data } = useCropPledgeInsuranceInformationContext();

  return (
    <Stack mt={6} gap={6}>
      <ReadOnlyYesNoRadio
        label={t(
          'cropPledge.pledgeInsuranceInformation.form.hasInsurance.label',
        )}
        defaultValue={
          data?.hasInsuranceInfo ? YES_NO_OPTIONS.YES : YES_NO_OPTIONS.NO
        }
      />
      {data?.hasInsuranceInfo && (
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
          <ReadOnlyField
            label={t(
              'cropPledge.pledgeInsuranceInformation.form.insuranceType.label',
            )}
            value={data?.insuranceType ?? t('common.toBeCompletedByBolsa')}
          />
          <ReadOnlyField
            label={t(
              'cropPledge.pledgeInsuranceInformation.form.currency.label',
            )}
            value={
              data?.currency
                ? t(`currency.${data.currency}`)
                : t('common.toBeCompletedByBolsa')
            }
          />
          <NumericReadOnlyField
            label={t('cropPledge.pledgeInsuranceInformation.form.amount.label')}
            value={data?.amount?.toString() ?? t('common.toBeCompletedByBolsa')}
          />
          <ReadOnlyField
            label={t(
              'cropPledge.pledgeInsuranceInformation.form.insuranceCompany.label',
            )}
            value={data?.insuranceCompany ?? t('common.toBeCompletedByBolsa')}
          />
          <ReadOnlyField
            label={t(
              'cropPledge.pledgeInsuranceInformation.form.streetName.label',
            )}
            value={data?.streetName ?? t('common.toBeCompletedByBolsa')}
          />
          <ReadOnlyField
            label={t(
              'cropPledge.pledgeInsuranceInformation.form.streetNumber.label',
            )}
            value={data?.streetNumber ?? t('common.toBeCompletedByBolsa')}
          />
          <ReadOnlyField
            label={t(
              'cropPledge.pledgeInsuranceInformation.form.province.label',
            )}
            value={data?.province?.name ?? t('common.toBeCompletedByBolsa')}
          />
          <ReadOnlyField
            label={t(
              'cropPledge.pledgeInsuranceInformation.form.locality.label',
            )}
            value={data?.locality?.name ?? t('common.toBeCompletedByBolsa')}
          />
          <ReadOnlyField
            label={t(
              'cropPledge.pledgeInsuranceInformation.form.postalCode.label',
            )}
            value={data?.postalCode ?? t('common.toBeCompletedByBolsa')}
          />
          <ReadOnlyField
            label={t(
              'cropPledge.pledgeInsuranceInformation.form.policyNumber.label',
            )}
            value={data?.policyNumber ?? t('common.toBeCompletedByBolsa')}
          />
        </SimpleGrid>
      )}
    </Stack>
  );
};

export default PledgeInsuranceInformationForm;
